export const loadStatisticsData = () => {
  return async (dispatch, getState, { api }) => {
    return api.getStatisticsData().then(
      async (data) => {
        return {
          wasSuccessful: true,
          statisticsData: data,
        };
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
